<template>
    <div class="prod-item-page" v-if="curProd" :class="{ 'slimMode': isSlimMode() }">
        <Header v-if="!isSlimMode()" class="header"></Header>
        <div class="page-container" id="page-container">
            <div class="prod-item-header-container" :class="{ 'alternative-layout': useAlternativeLayout }">
                <div class="image-container">
                    <!-- Blurred background -->
                    <img class="blurback" v-if="curProd.productImages && curProd.productImages.large != null"
                        :src="getImagesURL(curProd, 'productImages', 'large')" alt="">

                    <!-- Image in front (normal) -->
                    <img v-if="curProd.productImages && curProd.productImages.large != null"
                        :src="getImagesURL(curProd, 'productImages', 'large')" alt="">

                    <!-- Fallback quando não há imagem -->
                    <img v-else :src="noImageSrc" alt="">
                </div>
                <div class="data-container">
                    <div class="details-container">
                        <h1 v-text="getProductLanguage(curProd, 'productName')"></h1>
                    </div>
                    <div class="price-container">
                        <span class="price" v-if="showPrice()" v-text="formatMoney(totalPrice)">
                        </span>
                        <QuantityControl :quantity="curProd.quantity" @circleBtnRemove="decreaseQtty()"
                            @circleBtnAdd="increaseQtty()"></QuantityControl>
                    </div>
                </div>
                <div class="details-container" v-if="curProd.productDescription">
                    <p v-text="getString('descricao') + (getProductLanguage(curProd, 'productDescription'))"></p>
                </div>
            </div>

            <template v-if="isSimpleProduct()">
                <div class="observations-container" v-for="(obc, key) in curProd.observationsChoice" :key="key">
                    <span class="grupo-op-name">
                        <span v-text="getProductLanguage(obc, 'obsGroupName')"></span>
                        <span
                            v-text="`${curProd.observations.length || 0} / ${curProd.observationsChoice[key].maxQuantity || (obc.observations || []).length}`"></span>
                    </span>
                    <div class="min-observations-message" v-if="obc.minQuantity > 0" :class="{'red-text': curProd.observations.length < obc.minQuantity}">{{ getMessageObservationsMinQuantity(obc.minQuantity) }}</div>
                    <div class="obs-item-container">
                        <div class="item-obs" v-for="(obs, key2) in removeBlockedProdsObs(obc.observations)"
                            :key="key2" :class="{'selected': obsIsSelected(obs)}">
                            <div class="container-input">
                                <input class="styled-input" :id="key + obs.obsCode" type="checkbox" :value="obs"
                                    v-model="curProd.observations" @change="validateObs(obs, $event)">
                                <span class="checkmark"></span>
                            </div>
                            <label style="display: block; margin: auto 0;" :for="key + obs.obsCode">
                                <span v-text="getProductLanguage(obs, 'obsName')"></span>
                                <span class="obs-price" v-if="obs.price" v-text="` + ${formatMoney(obs.price)}`"></span>
                            </label>
                        </div>
                        <!-- Este bloco voltará a ser utilizado caso as observações passem a ter quantidades editáveis novamente -->
                        <!-- <div class="item-obs" :class="{'quantity-control': obs.quantity !== undefined}" v-for="(obs, key2) in obc.observations" :key="key2">
                            <div v-if="obs.quantity === undefined" class="container-input">
                                <input class="styled-input" :id="key + obs.obsCode" type="checkbox" :value="obs" v-model="curProd.observations" @change="validateObs(obs, $event)">
                                <span class="checkmark"></span>
                            </div>
                            <QuantityControl v-else
                                :quantity="obc.observations[key2].quantity || 0"
                                @circleBtnRemove="decreaseObservationQtty(key, key2)"
                                @circleBtnAdd="increaseObservationQtty(key, key2)">
                            </QuantityControl>
                            <label style="display: block; margin: auto 0;" :for="key + obs.obsCode" >
                                <span v-text="obs.obsName"></span>
                                <span v-if="obs.price" v-text="` + ${formatMoney(obs.price)}`"></span>
                            </label>
                        </div> -->
                    </div>
                </div>
            </template>

            <!-- Observação Digitada -->
            <div class="observations-container" v-if="exibeObsDigitada">
                <span class="grupo-op-name">
                    <span>{{ getString('observacao_livre') }}</span>
                </span>
                <!-- <textarea v-model="typedObs" class="typed-obs-text" id="typed-obs" rows="5" maxlength="25" @focus="show"></textarea> -->
                <div id="typed-obs" ref="typedObsDiv" class="div-input-android" @click="editObs"></div>
            </div>
            <div id="keyboard-filler" v-if="editingObs"></div>

            <div class="row">
                <transition-group :name="goingForward ? 'slide-right' : 'slide-left'">
                    <WizardStep v-for="(combo, key) in curProd.productGroups" :key="'wizard-step-key-' + key" :id="key"
                        :combo="combo" :zindex="itensLeft - key"
                        :chosen="curProd.productComboRaw && curProd.productComboRaw[key]"
                        :fatherProdCode="curProd.productCode" :fatherPrint="curProd.productPrint" :depth="key"
                        :curComboKey="curComboKey" :mutexData="mutexData"
                        :isEditing="$route.params.product !== undefined"
                        :alternativeLayoutCounter="alternativeLayoutCounter"
                        v-show="!combo.listed && (!useAlternativeLayout || wizardStepInEvidence === key)"
                        @comboOption="comboOption" @updateComboPrice="updateComboPrice"
                        @clearSelectedMutex="clearSelectedMutex" @updateNextButton="updateNextButton"
                        @openSelectMutexModal="openSelectMutexModal" :blockProds="blockProds">
                    </WizardStep>
                </transition-group>
            </div>
        </div>

        <SelectMutexModal v-if="showSelectMutexModal" :groupsData="groupsData" :calledOnMounted="calledOnMounted"
            @closeSelectMutexModal="closeSelectMutexModal" @pickMutexGroup="pickMutexGroup">
        </SelectMutexModal>

        <div class="prod-item-footer">
            <DefaultButton v-if="showCancelButton()" :text="getString('cancelar')" outlined="true"
                @defaultBtnClick="cancel()">
            </DefaultButton>
            <DefaultButton v-else :text="getString('voltar')" @defaultBtnClick="previousWizardStep()"></DefaultButton>

            <DefaultButton v-if="showAddToCartButton()"
                :text="this.$route.params.product ? getString('confirmar_edicao') : getString('adicionar_ao_carrinho')" :disabled="minObs"
                @defaultBtnClick="addToCart()" :class="{ 'disabled': wait }">
            </DefaultButton>
            <DefaultButton v-else :text="getString('proximo')" :disabled="!enabledNextButton"
                @defaultBtnClick="nextWizardStep()" :class="{ 'shake-button': enabledNextButton && !preventShaking }">
            </DefaultButton>
        </div>

        <div class="keyboard-overlay" v-if="editingObs" @click="closeKeyboard"></div>
        <AndroidKeyboard id="android-keyboard" v-if="editingObs" :inputElement="inputElement" :layout="layout">
        </AndroidKeyboard>
        <!-- <vue-touch-keyboard id="keyboard" :options="options" v-if="visible" :layout="layout" :cancel="hide" :accept="accept" :input="input" /> -->
    </div>
</template>

<script>
import Util from '@/assets/libs/util'
import CartController from '@/assets/controllers/CartController'
import ProductController from '@/assets/controllers/ProductController'
import Header from '@/components/Header'
import DefaultButton from '@/components/DefaultButton'
import QuantityControl from '@/components/QuantityControl'
import WizardStep from '@/components/WizardStep'
import SelectMutexModal from '@/components/SelectMutexModal'
import eventModule from '@/assets/libs/eventModule'
import LocaleController from '@/assets/controllers/LocaleController'
// import Vue from 'vue'
// import VueTouchKeyboard from 'vue-touch-keyboard'
// import style from 'vue-touch-keyboard/dist/vue-touch-keyboard.css'
import keyboardLayout from '@/assets/libs/keyboardLayout'
import AndroidKeyboard from '@/components/AndroidKeyboard/AndroidKeyboard'
import PromotionalCampaignsController from '@/assets/controllers/PromotionalCampaignsController'
import ClarityController from '../assets/controllers/ClarityController'

// Vue.use(VueTouchKeyboard)
// Vue.use(style)

export default {
    name: 'ProductItem',
    components: {
        Header,
        DefaultButton,
        QuantityControl,
        WizardStep,
        SelectMutexModal,
        AndroidKeyboard
        // 'vue-touch-keyboard': VueTouchKeyboard.component
    },
    data () {
        return {
            inputElement: null,
            layout: keyboardLayout.TEXT,
            editingObs: false,
            // visible: false,
            // layout: 'normal',
            // options: {
            //     useKbEvents: false,
            //     preventClickEvent: false
            // },
            input: null,
            noImageSrc: null,
            curProd: null,
            treatedComboItems: [],
            hasToPickOptions: false,
            itensLeft: 0,
            curComboKey: 0,
            mutexData: null,
            mutexDataBkp: null,
            blockProds: [],
            useAlternativeLayout: Util.getLocalConfigs('useAlternativeLayout'),
            alternativeLayoutCounter: 1,
            wizardStepInEvidence: 0,
            enabledNextButton: false,
            calledOnMounted: false,
            preventShaking: false,
            goingForward: true,
            exibeObsDigitada: false,
            typedObs: '',
            showSelectMutexModal: false,
            groupsData: [],
            totalPrice: 0,
            wait: false,
            junk: require('../../static/icons/junk-icon.png'),
            enableJumpGroup: Util.getLocalConfigs('avancagrupomax'),
            minObs: false
        }
    },
    mounted () {
        this.noImageSrc = Util.getConfigImage('noImage') ? Util.getConfigImage('noImage') : this.junk
        this.curProd = this.$route.params.product || this.$route.params
        this.blockProds = Util.getLocalVar('blockProds')
        this.exibeObsDigitada = Util.getLocalConfigs('permiteObsDigitada') && this.isSimpleProduct()

        if (this.exibeObsDigitada) {
            this.typedObs = this.curProd.typedObs ? this.curProd.typedObs : ''
        }
        this.addProductGroupCodeOnItem()
        this.mutexData = this.curProd.mutexData ? this.curProd.mutexData : this.buildMutexData()
        this.mutexDataBkp = Util.deepCopy(this.mutexData)
        this.curProd.productGroups.forEach(p => delete p.listed)
        this.curProd.productComboBkp = this.curProd.productCombo ? Util.deepCopy(this.curProd.productCombo) : []
        this.curProd.observationsBkp = this.curProd.observations ? Util.deepCopy(this.curProd.observations) : []
        this.curProd.productGroupsBkp = this.curProd.productGroups ? Util.deepCopy(this.curProd.productGroups) : []
        this.curProd.productComboRawBkp = this.curProd.productComboRaw ? Util.deepCopy(this.curProd.productComboRaw) : []

        if (this.curProd && this.curProd.productCode) {
            this.curProd.quantity = this.curProd.quantity || 1
            this.curProd.totalItemPrice = this.$route.params.product ? parseFloat(this.curProd.totalItemPrice) : parseFloat(this.curProd.price)

            this.curProd.observations = this.$route.params.product ? this.curProd.observations : []
            this.curProd.observationsChoice && this.curProd.observationsChoice.forEach(obc => {
                (obc.observations || []).forEach(obs => {
                    obs.obsGroupCode = obc.obsGroupCode
                })
            })

            // Se o usuário entrou nesta tela para editar um produto, este bloco atualiza as quantidades no
            // array observationsChoice de acordo com as quantidades no array observations, caso necessário
            if (this.curProd.observations.length > 0) {
                this.curProd.observations.forEach(obs => {
                    if (obs.quantity !== undefined && obs.quantity > 0) {
                        for (let i = 0; i < this.curProd.observationsChoice.length; i++) {
                            let obsIndex = this.curProd.observationsChoice[i].observations.findIndex(element => {
                                return element.obsCode === obs.obsCode &&
                                    element.obsGroupCode === obs.obsGroupCode &&
                                    element.obsName === obs.obsName &&
                                    element.price === obs.price
                            })
                            if (obsIndex !== -1) {
                                this.curProd.observationsChoice[i].observations[obsIndex].quantity = obs.quantity
                            }
                        }
                    }
                })
            }

            this.curProd.productCombo = this.$route.params.product ? this.curProd.productCombo : []
        } else {
            this.cancel()
        }

        if (this.useAlternativeLayout && !this.isSimpleProduct()) {
            this.updateNextButton()
            this.handleFirstGroupMutexCase()
        }

        this.minObs = this.$route.params.product ? false : (!(this.curProd.productGroups && this.curProd.productGroups.length > 0) && !this.checkMinObs())
        if (this.curProd.productGroups && this.curProd.productGroups.length > 0) {
            CartController.setProductSequence(this.curProd, null, 0, 0)
        }
        this.updateComboPrice()
    },
    methods: {
        addProductGroupCodeOnItem: function () {
            this.curProd.productGroups.forEach(prod => {
                if (prod.productGroupCode) {
                    prod.productGroupItems.forEach(gi => {
                        gi.productGroupCode = prod.productGroupCode
                        gi.subItemProductGroups.forEach(sgi => {
                            if (sgi.subProductGroupCode) {
                                sgi.subProductGroupItems.forEach(si => {
                                    si.subProductGroupCode = sgi.subProductGroupCode
                                })
                            }
                        })
                    })
                }
            })
        },
        getString: function (key) {
            return LocaleController.getString(key)
        },
        showPrice: function () {
            let showMinPriceDifference = Util.getLocalConfigs('showMinPriceDifference')
            return (this.curProd.productPrint === 'S' && !showMinPriceDifference) || this.curProd.productGroups.length === 0
        },
        isSlimMode: function () {
            return Util.isSlimMode()
        },
        accept: function (text) {
            this.hide()
        },
        show: function (e) {
            if (!Util.isAndroidMode()) {
                this.input = e.target

                if (!this.visible) {
                    this.visible = true
                }

                let container = document.getElementById('page-container')
                setTimeout(() => {
                    container.scrollTo(0, container.scrollHeight)
                }, 100)
            }
        },
        hide: function () {
            this.visible = false
        },
        clearSelectedMutex: function (productGroupMutex) {
            let newMutexData = Util.deepCopy(this.mutexData)
            newMutexData[productGroupMutex].selectedMutexCode = null
            this.mutexData = newMutexData
        },
        buildMutexData: function () {
            let mutexData = {}

            this.curProd.productGroups.forEach((group, index) => {
                if (group.productGroupMutex && group.productGroupMutex !== null) {
                    if (!mutexData[group.productGroupMutex]) {
                        mutexData[group.productGroupMutex] = {
                            groups: [],
                            selectedMutexCode: null,
                            alternativeLayoutPickedGroupIndex: null
                        }
                    }
                    mutexData[group.productGroupMutex].groups.push({
                        productGroupName: group.productGroupName,
                        productGroupCode: group.productGroupCode,
                        productGroupIndex: index
                    })
                }
            })

            let mutexKeys = Object.keys(mutexData)
            mutexKeys.forEach(key => {
                // Se o grupo mutex contiver apenas um grupo de produtos, ele não precisa ser tratado como mutex
                if (mutexData[key].groups.length < 2) {
                    delete mutexData[key]
                }
            })

            return mutexData
        },
        getImagesURL: function (prod, prop, size) {
            return Util.getImagesUrl(prod, prop, size)
            // return Util.getLocalConfigs('urlIMGOdhenInterface')
        },
        formatMoney: function (price) {
            return Util.formatMoney(price)
        },
        validateObs: function (obs, clickEvent) {
            let obsGroup = this.curProd.observationsChoice.find(element => element.obsGroupCode === obs.obsGroupCode)
            let maxObservations = obsGroup.maxQuantity || 0
            let minObservations = obsGroup.minQuantity || 0
            let groupSelectedObs = []

            if (this.curProd.observations && this.curProd.observations.length) {
                groupSelectedObs = this.curProd.observations.filter(element => element.obsGroupCode === obs.obsGroupCode)
            }

            let groupObsNumber = (groupSelectedObs && groupSelectedObs.length) || 0
            let checkObsMax = ((maxObservations != null && maxObservations !== 0) && groupObsNumber > maxObservations && clickEvent.srcElement.checked)
            let checkObsMin = (minObservations === 0) || ((minObservations != null && minObservations !== 0) && groupObsNumber >= minObservations)
            if (checkObsMax) {
                this.curProd.observations.pop()
                clickEvent.srcElement.checked = false
            }
            this.minObs = !checkObsMin
            if (clickEvent.srcElement.checked) {
                ClarityController.event('usuario_selecionou_observacao')
                ClarityController.setTag('observacao_selecionada', obs.obsName)
            } else {
                ClarityController.event('usuario_removeu_observacao')
                ClarityController.setTag('observacao_deselecionada', obs.obsName)
            }
            this.updateComboPrice()
            // this.$forceUpdate()
        },
        priceUpdate: function () {
            ProductController.priceUpdate(this.curProd)
            this.$forceUpdate()
        },
        cancel: function () {
            Util.showConfirmationDialogSync(this.$modal, () => {
                this.curProd.productCombo = Util.deepCopy(this.curProd.productComboBkp)
                this.curProd.productGroups = Util.deepCopy(this.curProd.productGroupsBkp)
                this.curProd.productComboRaw = Util.deepCopy(this.curProd.productComboRawBkp)
                this.curProd.observations = Util.deepCopy(this.curProd.observationsBkp)
                this.curProd.mutexData = Util.deepCopy(this.mutexDataBkp)
                this.priceUpdate()
                this.finish(false)
            }, this.getString('cancelar_selecao'), () => {})
        },
        finish: function (addToCart = true) {
            if (addToCart) {
                if (this.$route.params.product) {
                    CartController.editProduct(this.curProd, this.$route.params.key)
                } else {
                    CartController.addToCart(this.curProd)
                }
            }
            this.$router.push({
                name: this.$route.params.routeBack || 'Home',
                params: { catGroupName: this.curProd.catGroupName, subGroupIndex: this.curProd.subGroupIndex }
            })
        },
        addToCart: function () {
            this.itensLeft = this.curProd.productGroups.length
            this.hasToPickOptions = false
            this.curProd.productCombo = []
            this.curProd.productComboRaw = this.curProd.productComboRaw || []
            if (!this.itensLeft || this.itensLeft === 0) {
                CartController.setProductSequence(this.curProd, null, 0, 0)
            }
            // this.curProd.productComboRaw.forEach(c => {
            //     if (c != null) this.curProd.productCombo = this.curProd.productCombo.concat(c)
            // })
            const filteredProductComboRaw = this.curProd.productComboRaw.filter(c => c != null).map(c => c)
            this.curProd.productCombo = [...this.curProd.productCombo, ...filteredProductComboRaw].flat(1)

            let escholhaCorrente = this.curProd.productComboRaw
            let comboCorrente = this.curProd.productGroups
            let carrinhoPronto = true
            let mutexData = this.mutexData
            let self = this

            comboCorrente.reverse().forEach(function (product, i) {
                let isMutex = product.productGroupMutex && mutexData[product.productGroupMutex] != null
                let hasSelectedMutex = mutexData[product.productGroupMutex] && mutexData[product.productGroupMutex].selectedMutexCode != null
                let isSelectedMutex = isMutex && mutexData[product.productGroupMutex].selectedMutexCode === product.productGroupCode

                if (product.productGroupMin > 0 && !escholhaCorrente[comboCorrente.length - (i + 1)] && (!isMutex || !hasSelectedMutex || isSelectedMutex)) {
                    carrinhoPronto = false
                    let errorMessage = self.getString('voce_precisa_selecionar_algum') + product.productGroupName
                    Util.showErrorNotification({ title: errorMessage, text: null })
                } else if (escholhaCorrente[comboCorrente.length - (i + 1)] && (!isMutex || !hasSelectedMutex || isSelectedMutex)) {
                    let totalGroupSelected = 0
                    escholhaCorrente[comboCorrente.length - (i + 1)].forEach(product => {
                        totalGroupSelected += product.quantity ? product.quantity : 1
                    })
                    if (totalGroupSelected < product.productGroupMin) {
                        carrinhoPronto = false
                        let errorMessage = self.getString('voce_precisa_selecionar_algum') + product.productGroupName
                        Util.showErrorNotification({ title: errorMessage, text: null })
                    }
                }
            })
            comboCorrente.reverse()
            if (carrinhoPronto) {
                this.curProd.mutexData = this.mutexData

                if (this.exibeObsDigitada) {
                    this.curProd.typedObs = this.typedObs.trim()
                }
                this.wait = true
                PromotionalCampaignsController.updatePricesPromotionalCampaigns(this.curProd).then(() => {
                    this.wait = false
                    this.priceUpdate()
                    this.finish()
                })
                // this.priceUpdate()
                // this.finish()
            }
        },
        decreaseQtty: function () {
            if (this.curProd.quantity > 1) {
                this.curProd.quantity -= 1
            }
            this.updateComboPrice()
            // this.$forceUpdate()
        },
        increaseQtty: function () {
            this.curProd.quantity += 1
            this.updateComboPrice()
            // this.$forceUpdate()
        },
        decreaseObservationQtty: function (key, key2) {
            if (this.curProd.observationsChoice[key].observations[key2].quantity > 0) {
                let obsIndex = this.curProd.observations.findIndex(obs => {
                    return obs.obsCode === this.curProd.observationsChoice[key].observations[key2].obsCode &&
                        obs.obsGroupCode === this.curProd.observationsChoice[key].observations[key2].obsGroupCode &&
                        obs.obsName === this.curProd.observationsChoice[key].observations[key2].obsName &&
                        obs.price === this.curProd.observationsChoice[key].observations[key2].price &&
                        obs.quantity === this.curProd.observationsChoice[key].observations[key2].quantity
                })

                this.curProd.observations[obsIndex].quantity -= 1
                this.curProd.observationsChoice[key].observations[key2].quantity -= 1
                if (this.curProd.observations[obsIndex].quantity === 0) {
                    this.curProd.observations.splice(obsIndex, 1)
                }

                this.priceUpdate()
                this.$forceUpdate()
            }
        },
        increaseObservationQtty: function (key, key2) {
            if (this.curProd.observationsChoice[key].observations[key2].quantity === 0) {
                this.curProd.observationsChoice[key].observations[key2].quantity += 1
                let observationCopy = Util.deepCopy(this.curProd.observationsChoice[key].observations[key2])
                this.curProd.observations.push(observationCopy)
            } else {
                let obsIndex = this.curProd.observations.findIndex(obs => {
                    return obs.obsCode === this.curProd.observationsChoice[key].observations[key2].obsCode &&
                        obs.obsGroupCode === this.curProd.observationsChoice[key].observations[key2].obsGroupCode &&
                        obs.obsName === this.curProd.observationsChoice[key].observations[key2].obsName &&
                        obs.price === this.curProd.observationsChoice[key].observations[key2].price &&
                        obs.quantity === this.curProd.observationsChoice[key].observations[key2].quantity
                })
                this.curProd.observations[obsIndex].quantity += 1
                this.curProd.observationsChoice[key].observations[key2].quantity += 1
            }

            this.priceUpdate()
            this.$forceUpdate()
        },
        comboOption: function (comboItemChoices) {
            this.curProd.productComboRaw = this.curProd.productComboRaw || []
            CartController.setProductSequence(this.curProd, null, 0, 0)
            // Cada item filho precisa levar a referência de imprime sim/não do grupo ao qual pertence
            let groupPrint = this.curProd.productGroups[comboItemChoices.key].productGroupPrint
            comboItemChoices.option.forEach(item => {
                item.groupPrint = groupPrint
            })
            this.curProd.productComboRaw[comboItemChoices.key] = comboItemChoices.option

            // Trata as informações de grupos Mutex, se for o caso
            let mutexCode = this.curProd.productGroups[comboItemChoices.key].productGroupMutex
            let isMutexGroup = mutexCode && this.mutexData[mutexCode]

            if (isMutexGroup) {
                let newMutexData = Util.deepCopy(this.mutexData)

                if (comboItemChoices.option.length > 0) {
                    newMutexData[mutexCode].selectedMutexCode = this.curProd.productGroups[comboItemChoices.key].productGroupCode
                } else {
                    newMutexData[mutexCode].selectedMutexCode = null
                }

                this.mutexData = newMutexData
            }

            let groupKey = comboItemChoices.key
            let groupMaxItems = this.curProd.productGroups[groupKey].productGroupMax
            let groupSelectedItems = 0
            comboItemChoices.option.forEach(prod => {
                groupSelectedItems += prod.quantity || 1
            })
            this.updateComboPrice()
            this.updateNextButton()
            /* if (groupSelectedItems === groupMaxItems && !this.useAlternativeLayout) {
                eventModule.$emit('checkHideGroup', groupKey)
                this.jumpGroup(groupKey, isMutexGroup, mutexCode)
            } */
            if ((groupSelectedItems === groupMaxItems) && this.enableJumpGroup && this.enabledNextButton && !this.showAddToCartButton()) {
                this.nextWizardStep()
            }
            this.$forceUpdate()
        },
        showAddToCartButton: function () {
            return !this.useAlternativeLayout || this.showingLastWizardStep() || this.isSimpleProduct()
        },
        showingLastWizardStep: function () {
            let isTheLastGroup = this.curProd.productGroups && this.curProd.productGroups.length === this.wizardStepInEvidence + 1
            return isTheLastGroup || !this.hasGroupAfterCurrentMutex()
        },
        hasGroupAfterCurrentMutex: function () {
            let thisGroup = this.curProd.productGroups[this.wizardStepInEvidence]
            let isMutex = thisGroup && thisGroup.productGroupMutex && this.mutexData[thisGroup.productGroupMutex] != null

            if (isMutex) {
                let groups = this.curProd.productGroups || []
                let hasGroupAfter = false

                for (let i = this.wizardStepInEvidence + 1; i < groups.length; i++) {
                    let group = groups[i]
                    if (group.productGroupMutex !== thisGroup.productGroupMutex) {
                        hasGroupAfter = true
                        break
                    }
                }

                return hasGroupAfter
            } else {
                return true
            }
        },
        showCancelButton: function () {
            return !this.useAlternativeLayout || this.wizardStepInEvidence === 0 || !this.hasGroupBeforeCurrentMutex()
        },
        hasGroupBeforeCurrentMutex: function () {
            let thisGroup = this.curProd.productGroups[this.wizardStepInEvidence]
            let isMutex = thisGroup && thisGroup.productGroupMutex && this.mutexData[thisGroup.productGroupMutex] != null

            if (isMutex) {
                let groups = this.curProd.productGroups || []
                let hasGroupBefore = false

                for (let i = this.wizardStepInEvidence - 1; i >= 0; i--) {
                    let group = groups[i]
                    if (group.productGroupMutex !== thisGroup.productGroupMutex) {
                        hasGroupBefore = true
                        break
                    }
                }

                return hasGroupBefore
            } else {
                return true
            }
        },
        updateNextButton: function () {
            if (this.useAlternativeLayout && (this.curProd.productComboRaw != null || this.firstGroupIsOptional())) {
                this.checkNextButton()
            }
        },
        firstGroupIsOptional: function () {
            try {
                return this.curProd.productGroups[0].productGroupMin === 0
            } catch (error) {
                return false
            }
        },
        checkNextButton: function () {
            let currentGroup = this.curProd.productGroups[this.wizardStepInEvidence]
            let minForCurrentGroup = currentGroup.productGroupMin
            let groupPickedProds = (this.curProd.productComboRaw && this.curProd.productComboRaw[this.wizardStepInEvidence])
                ? this.curProd.productComboRaw[this.wizardStepInEvidence] : []
            let pickedFromCurrentGroup = 0

            groupPickedProds.forEach(prod => {
                pickedFromCurrentGroup += prod.quantity || 1
            })

            if (pickedFromCurrentGroup >= minForCurrentGroup) {
                this.enableNextButton()
            } else {
                this.disableNextButton()
            }
        },
        enableNextButton: function () {
            this.enabledNextButton = true
            this.$forceUpdate()
        },
        disableNextButton: function () {
            this.preventShaking = false
            this.enabledNextButton = false
        },
        previousWizardStep: function () {
            this.goingForward = false
            let previousGroup = this.curProd.productGroups[this.wizardStepInEvidence - 1]
            let previousGroupIsMutex = previousGroup.productGroupMutex && this.mutexData[previousGroup.productGroupMutex] != null

            if (previousGroupIsMutex) {
                let mutexKey = previousGroup.productGroupMutex
                let pickedGroupIndex = this.mutexData[mutexKey].alternativeLayoutPickedGroupIndex

                if (this.wizardStepInEvidence !== pickedGroupIndex) {
                    this.alternativeLayoutCounter--
                    this.wizardStepInEvidence = pickedGroupIndex
                } else {
                    this.goToPreviousNotMutex(mutexKey)
                }
            } else {
                this.alternativeLayoutCounter--
                this.wizardStepInEvidence--
            }

            this.preventShaking = true
            this.checkNextButton()
        },
        nextWizardStep: function (calledOnMounted = false) {
            this.goingForward = true
            if (this.enabledNextButton || calledOnMounted) {
                let nextGroup = this.curProd.productGroups[this.wizardStepInEvidence + 1]
                let nextGroupIsMutex = nextGroup.productGroupMutex && this.mutexData[nextGroup.productGroupMutex] != null

                if (nextGroupIsMutex) {
                    let mutexKey = nextGroup.productGroupMutex
                    let alreadyPickedMutexGroup = this.mutexData[mutexKey].alternativeLayoutPickedGroupIndex != null

                    if (alreadyPickedMutexGroup) {
                        let pickedGroupIndex = this.mutexData[mutexKey].alternativeLayoutPickedGroupIndex

                        if (this.wizardStepInEvidence !== pickedGroupIndex) {
                            if (!calledOnMounted) this.alternativeLayoutCounter++
                            this.wizardStepInEvidence = pickedGroupIndex
                        } else if (!calledOnMounted) {
                            this.goToNextNotMutex(mutexKey)
                        }
                    } else {
                        this.openSelectMutexModal(mutexKey)
                    }
                } else {
                    this.alternativeLayoutCounter++
                    this.wizardStepInEvidence++
                }
                setTimeout(() => {
                    eventModule.$emit('checkNextPreselect', this.wizardStepInEvidence)
                    this.checkNextButton()
                }, 500)
                // this.checkNextButton()
            }
        },
        goToNextNotMutex: function (mutexKey) {
            let groups = this.curProd.productGroups || []

            for (let i = this.wizardStepInEvidence; i < groups.length; i++) {
                let currentGroup = groups[i]
                if (currentGroup.productGroupMutex !== mutexKey) {
                    this.alternativeLayoutCounter++
                    this.wizardStepInEvidence = i
                    break
                }
            }
        },
        goToPreviousNotMutex: function (mutexKey) {
            let groups = this.curProd.productGroups || []

            for (let i = this.wizardStepInEvidence; i >= 0; i--) {
                let currentGroup = groups[i]
                if (currentGroup.productGroupMutex !== mutexKey) {
                    this.alternativeLayoutCounter--
                    this.wizardStepInEvidence = i
                    break
                }
            }
        },
        handleFirstGroupMutexCase: function () {
            let firstGroup = this.curProd.productGroups[0]
            let firstGroupIsMutex = firstGroup.productGroupMutex && this.mutexData[firstGroup.productGroupMutex] != null

            if (firstGroupIsMutex) {
                let mutexKey = firstGroup.productGroupMutex
                let calledOnMounted = true
                this.openSelectMutexModal(mutexKey, calledOnMounted)
            }
        },
        openSelectMutexModal: function (mutexKey, calledOnMounted = false) {
            this.buildGroupsData(mutexKey)
            this.calledOnMounted = calledOnMounted
            this.showSelectMutexModal = true
        },
        closeSelectMutexModal: function () {
            this.showSelectMutexModal = false
        },
        pickMutexGroup: function (selectedGroupIndex, mutexKey, calledOnMounted) {
            let firstTimePicked = this.mutexData[mutexKey].alternativeLayoutPickedGroupIndex == null
            this.mutexData[mutexKey].alternativeLayoutPickedGroupIndex = selectedGroupIndex

            if (firstTimePicked) {
                this.nextWizardStep(calledOnMounted)
            } else {
                this.changePickedMutex(mutexKey)
            }
        },
        changePickedMutex: function (mutexKey) {
            let pickedGroupIndex = this.mutexData[mutexKey].alternativeLayoutPickedGroupIndex

            if (pickedGroupIndex !== this.wizardStepInEvidence) {
                this.clearCurrentMutexChoices()
                this.wizardStepInEvidence = pickedGroupIndex
                this.checkNextButton()
            }
        },
        clearCurrentMutexChoices: function () {
            eventModule.$emit('deleteAllChoices', this.wizardStepInEvidence)
        },
        buildGroupsData: function (mutexKey) {
            this.groupsData = []
            let groups = this.curProd.productGroups || []

            groups.forEach((group, idx) => {
                let isSameMutex = group.productGroupMutex === mutexKey
                if (isSameMutex) {
                    this.groupsData.push({
                        name: group.productGroupName,
                        index: idx,
                        mutexKey: mutexKey
                    })
                }
            })
        },
        jumpGroup: function (groupKey, isMutexGroup, mutexCode) {
            if (isMutexGroup) {
                let nextGroups = (this.curProd.productGroups || []).slice(groupKey + 1)
                let nextNotMutexIndex = nextGroups.findIndex(element => element.productGroupMutex !== mutexCode)
                if (nextNotMutexIndex !== -1) {
                    let groupsToJump = groupKey + 1 + nextNotMutexIndex
                    location.hash = '#' + groupsToJump
                    eventModule.$emit('checkNextPreselect', groupsToJump)
                }
            } else {
                let nextGroupHash = groupKey + 1
                let jumpToNextPreselect = this.jumpToNextPreselect(nextGroupHash)
                if (jumpToNextPreselect) nextGroupHash++
                location.hash = '#' + nextGroupHash
                eventModule.$emit('checkNextPreselect', nextGroupHash)
            }
        },
        jumpToNextPreselect: function (nextGroupHash) {
            try {
                let isOptionalGroup = false
                let isFollowedByPreselec = false
                if (this.curProd.productGroups && this.curProd.productGroups[nextGroupHash] && this.curProd.productGroups[nextGroupHash].productGroupMin === 0) {
                    isOptionalGroup = true
                }
                if (this.curProd.productGroups && this.curProd.productGroups[nextGroupHash + 1] &&
                    this.curProd.productGroups[nextGroupHash + 1].productGroupMax === 1 &&
                    this.curProd.productGroups[nextGroupHash + 1].productGroupItems
                ) {
                    let hasAnyPreselec = this.curProd.productGroups[nextGroupHash + 1].productGroupItems.filter(element => element.subItemPreSelected === 'S')
                    if (hasAnyPreselec) {
                        isFollowedByPreselec = true
                    }
                }
                return isOptionalGroup && isFollowedByPreselec
            } catch (error) {
                return false
            }
        },
        isSimpleProduct: function () {
            return (this.curProd.productGroups || []).length === 0
        },
        getProductLanguage: function (product, index) {
            return LocaleController.getIndexLanguages(product, index)
        },
        updateComboPrice: function () {
            let product = Util.deepCopy(this.curProd)
            product.productCombo = []
            product.productComboRaw = product.productComboRaw || []
            if (product.productComboRaw && product.productComboRaw.length > 0) {
                const filteredProductComboRaw = product.productComboRaw.filter(c => c != null).map(c => c)
                if (filteredProductComboRaw) {
                    product.productCombo = [...product.productCombo, ...filteredProductComboRaw].flat(1)
                }
            }
            product.mutexData = this.mutexData
            if (this.exibeObsDigitada) {
                product.typedObs = this.typedObs.trim()
            }
            ProductController.priceUpdate(product)
            this.totalPrice = product.totalItemPrice * product.quantity
            this.$forceUpdate()
        },
        getPrice: function () {
            this.totalPrice = this.formatMoney(this.totalPrice)
        },
        editObs: function () {
            this.inputElement = this.$refs.typedObsDiv
            this.editingObs = true

            let container = document.getElementById('page-container')
            setTimeout(() => {
                container.scrollTo(0, container.scrollHeight)
            }, 100)
        },
        closeKeyboard: function () {
            this.editingObs = false
            this.typedObs = this.$refs.typedObsDiv.innerText
        },
        removeBlockedProdsObs: function (obs) {
            return Util.removeBlockedProdsObs(obs)
        },
        obsIsSelected: function (obs) {
            if (!this.curProd || !this.curProd.observations || this.curProd.observations.length === 0) {
                return false
            }

            return this.curProd.observations.find(element => element.obsCode === obs.obsCode && element.obsGroupCode === obs.obsGroupCode && element.obsName === obs.obsName && element.price === obs.price)
        },
        getMessageObservationsMinQuantity: function (minQuantity) {
            return this.getString('escolha_pelo_menos') + ' ' + minQuantity + ' ' + (minQuantity > 1 ? this.getString('observacoes') : this.getString('observacao')) + ' *'
        },
        checkMinObs: function () {
            let minObsGroup = true
            this.curProd.observationsChoice.forEach(obsGroup => {
                if (obsGroup.minQuantity && obsGroup.minQuantity > 0) {
                    minObsGroup = false
                }
            })
            this.minObs = minObsGroup
            return minObsGroup
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@import (reference) url("../assets/common.less");

/* ==========================================================================
   LAYOUT CONTAINERS
   ========================================================================== */

.prod-item-page {
    background: white;
    font-size: 2rem;
}

.header {
    position: relative;
    display: block;
    height: 180px;
}

.page-container {
    position: relative;
    display: block;
    height: calc(100vh - 370px);
    overflow: auto;
}

/* ==========================================================================
   PRODUCT HEADER SECTION
   ========================================================================== */

.prod-item-page .prod-item-header-container {
    /* Container for product header elements */
    position: relative;
    display: block;
}

.prod-item-page .image-container {
    padding: 20px;

    img {
        height: 500px;
        object-fit: scale-down;
        margin: auto;
        display: block;
    }
}

.prod-item-page .data-container {
    display: grid;
    grid-template-rows: auto auto;
    padding: 0 0 30px 0;
    top: 0;
    margin-bottom: 0;
    padding-bottom: 0;
    position: relative;
    background: @white;

    &:before {
        content: '';
        position: absolute;
        inset: 0;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        pointer-events: none;
        opacity: 0.2;
        z-index: 0;
        background-color: @primary-light;
    }
}

.prod-item-page .details-container {
    padding: 15px 30px 15px 30px;
    display: flex;
    align-content: center;
    align-items: center;
    z-index: 1;

    p {
        padding: 0;
    }

    h1 {
        color: @primary-dark;
        font-size: 3rem;
        margin: 30px 0;
    }
}

.prod-item-page .price-container {
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 15px 0;

    .price {
        font-size: 2.8rem;
        position: relative;
        display: block;
        padding-right: 30px;
        color: var(--price-font-color);
    }
}

/* ==========================================================================
   ALTERNATIVE LAYOUT
   ========================================================================== */

.prod-item-page .prod-item-header-container.alternative-layout {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template: "prodimage prodimage"
        "datacontainer datacontainer"
        "description description";
    padding: 0;

    .image-container {
        position: relative;
        grid-area: prodimage;
        padding: 0;
        height: 400px;
        overflow: hidden;

        img {
            display: block;
            height: 100%;
            object-fit: contain;
        }

        .blurback {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            width: 100%;
            height: 100%;
            object-fit: cover;
            inset: 0;
            filter: blur(15px);
            transform: scale(1.2);
        }

        img:not(.blurback) {
            position: relative;
            z-index: 0;
        }
    }

    .data-container {
        display: flex;
        flex-direction: column;
        grid-area: datacontainer;

        .details-container {
            padding: 0;
            display: block;
            margin: auto;
            text-align: center;

            h1 {
                padding: 0 15px;
            }
        }

        .price-container {
            padding: 0 0 30px 0;
        }
    }

    .details-container {
        grid-area: description;
        display: block;
    }
}

/* ==========================================================================
   OBSERVATIONS SECTION
   ========================================================================== */

.prod-item-page .observations-container {
    position: relative;
    padding: 0 0 50px 0;
    // width: calc(100% - 60px);

    .grupo-op-name {
        position: relative;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        padding: 10px 15px;
        color: white;
        background: @primary-color;
        margin-bottom: 15px;

        span {
            display: inline-block;
            vertical-align: middle;
            font-weight: bold;
            font-size: 2.5rem;
            padding: 0 20px;
        }
    }
    .min-observations-message {
        font-size: 23px;
        padding: 0 30px;
        margin-bottom: 15px;
        &.red-text {
            color: red;
        }
    }

    .typed-obs-text {
        font-size: 32px;
        font-family: @default-font;
        width: 100%;
        resize: none;
        border: 2px solid @primary-color;
    }

    .obs-item-container {
        position: relative;
        display: grid;
        grid-template-columns: calc(50% - 7.5px) calc(50% - 7.5px);
        grid-column-gap: 15px;
        padding: 0 30px;

        .item-obs {
            // display: grid;
            margin-top: 15px;
            // grid-column-gap: 15px;
            // grid-template-columns: 15% calc(85% - 15px);
            display: flex;
            flex-direction: row;
            align-items: center;
            // border: 1px solid @primary-color;
            border-radius: 5px;
            box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.3);
            padding: 15px 15px;
            .container-input {
                display: none;
            }
            &.quantity-control {
                grid-template-columns: 40% calc(60% - 15px);
            }

            .obs-price {
                color: var(--price-font-color);
            }
            &.selected {
                box-shadow: 0 0 10px 0 rgba(19, 165, 0, 0.3);
                background-color: @primary-color;
                color: white;
                .obs-price {
                    color: white;
                }
            }
            label {
                width: 100%;
            }
        }
    }

    .div-input-android {
        position: relative;
        display: block;
        font-size: 32px;
        height: 180px;
        background-color: white;
        color: black;
        border: 2px solid @primary-color;
        padding: 20px;
    }
}

/* ==========================================================================
   KEYBOARD SECTION
   ========================================================================== */

.prod-item-page #keyboard-filler {
    height: 210px;
}

#keyboard {
    .keyboard;
    position: fixed;
    bottom: 0;
}

#android-keyboard {
    .keyboard;
    bottom: 60px;
    margin: auto;
}

.keyboard-overlay {
    z-index: 10;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
}

/* ==========================================================================
   SLIM MODE
   ========================================================================== */

.prod-item-page.slimMode {
    .page-container {
        height: calc(100vh - 240px);
        padding: 15px 0;

        .prod-item-header-container {
            position: sticky;
            top: 0;
            left: 0;
            right: 0;
            background: white;
            z-index: 1;
            display: block;
        }
    }
}

/* ==========================================================================
   FOOTER SECTION
   ========================================================================== */

.prod-item-footer {
    position: relative;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: space-between;
    background: rgba(0, 0, 0, 0.1);
    height: 130px;
    margin: auto;
    padding: 0 30px;

    button {
        position: relative;
        display: block;
        margin: auto;
        width: 45%;
    }
}

/* ==========================================================================
   STEP CONTAINER
   ========================================================================== */

.step-container {
    .full;
    position: absolute;
    top: 20%;
    left: 5%;
    right: 5%;
    bottom: inherit;
    z-index: 2;
    height: 915px;

    &:before {
        content: '';
        position: fixed;
        .full;
        background: rgba(0, 0, 0, 0.6);
    }

    .step-container-footer {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 100;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-evenly;
        align-items: center;

        button {
            display: inline-block;
        }
    }
}

/* ==========================================================================
   ANIMATIONS
   ========================================================================== */

.shake-button {
    animation: shakeShake 1s cubic-bezier(0.36, 0.07, 0.19, 0.97);
    animation-iteration-count: 1;
}

@keyframes shakeShake {
    0% {
        transform: rotateZ(4deg);
    }

    20% {
        transform: rotateZ(-4deg);
    }

    40% {
        transform: rotateZ(4deg);
    }

    60% {
        transform: rotateZ(-4deg);
    }

    80% {
        transform: rotateZ(4deg);
    }

    100% {
        transform: rotateZ(0deg);
    }
}

/* ==========================================================================
   SLIDE TRANSITIONS
   ========================================================================== */

.slide-right-enter-active {
    transition: all .2s ease-in-out;
    transition-delay: .2s;
}

.slide-right-leave-active {
    transition: all .2s ease-in-out;
}

.slide-right-enter {
    transform: translate(100vw);
}

.slide-right-leave-to {
    transform: translate(-100vw);
}

.slide-left-enter-active {
    transition: all .2s ease-in-out;
    transition-delay: .2s;
}

.slide-left-leave-active {
    transition: all .2s ease-in-out;
}

.slide-left-enter {
    transform: translate(-100vw);
}

.slide-left-leave-to {
    transform: translate(100vw);
}

/* ==========================================================================
   RESPONSIVE MEDIA QUERIES
   ========================================================================== */

/* Mobile Devices (Gertec SK210) */
@media (max-width: 698px) {
    .header {
        height: 50px;
    }

    .page-container {
        height: calc(100vh - 140px);
    }
    .prod-item-page.slimMode {
        .page-container {
            height: calc(100vh - 110px) !important;
        }
    }

    .prod-item-page {
        font-size: 1.2rem;

        .prod-item-header-container.alternative-layout {
            .image-container {
                height: 150px;
            }
            .details-container {
                padding: 5px 10px 5px 10px;

                p {
                    font-size: 16px;
                    margin: 10px 0;
                }
            }

            .data-container {
                display: flex;
                flex-direction: column;
                grid-area: datacontainer;
                padding: 5px 0;
                .details-container {
                    h1 {
                        padding: 0 0;
                        margin: 0 0 5px 0;
                        font-size: 1.2em;
                    }
                }

                .price-container {
                    padding: 0;
                    .price {
                        font-size: 1.1em;
                    }
                }
            }
        }

        .observations-container {
            padding: 0;

            .grupo-op-name {
                padding: 5px 10px;
                margin-bottom: 5px;

                span {
                    font-weight: bold;
                    font-size: 1.2rem;
                }
            }

            .min-observations-message {
                font-size: 15px;
                margin-bottom: 5px;
            }
            .obs-item-container {
                grid-template-columns: calc(50% - 7.5px) calc(50% - 7.5px);
                grid-column-gap: 15px;

                .item-obs {
                    padding: 10px;
                    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.3);
                    margin-top: 5px;
                    grid-column-gap: 0;
                    grid-template-columns: 15% calc(85% - 10px);
                    font-size: 16px;
                    &.quantity-control {
                        grid-template-columns: 40% calc(60% - 15px);
                    }
                }
            }
        }

        #keyboard-filler {
            height: 150px;
        }

        &.slimMode {
            .page-container {
                padding: 10px 0;
                height: calc(100vh - 180px);
            }
        }
    }

    .prod-item-footer {
        grid-template-columns: auto auto;
        height: 60px;
        padding: 0 15px;

        button {
            box-shadow: 0px 0px 0px rgba(0, 0, 0, 0.4);
            width: 200px;
        }
    }

    #android-keyboard {
        .small-screen-keyboard;
        bottom: 30px;
    }
}

@media (min-width: 699px) and (max-width: 900px) {
    .header {
        height: 130px;
    }

    .page-container {
        height: calc(100vh - 290px);
    }

    .prod-item-page {
        font-size: 1rem;

        .prod-item-header-container.alternative-layout {
            .image-container {
                height: 260px;
            }
            .details-container {
                padding: 5px 30px 5px 30px;

                p {
                    font-size: 20px;
                    margin: 10px 0;
                }
            }

            .data-container {
                display: flex;
                flex-direction: column;
                grid-area: datacontainer;
                padding: 15px 0;
                .details-container {
                    padding: 0;
                    display: block;
                    margin: auto;
                    text-align: center;

                    h1 {
                        padding: 0 0;
                        margin: 0 0 15px 0;
                        font-size: 1.9em;
                    }
                }

                .price-container {
                    padding: 0;
                    .price {
                        font-size: 1.9em;
                    }
                }
            }
        }
        .observations-container {
                .grupo-op-name {
                    span {
                        font-weight: bold;
                        font-size: 1.6rem;
                    }
                }
                .min-observations-message {
                    font-size: 1.2rem;
                }
                .obs-item-container {
                    .item-obs {
                        font-size: 1.3rem;
                    }
                }
            }

        #keyboard-filler {
            height: 150px;
        }

        &.slimMode {
            .page-container {
                padding: 10px 0;
                height: calc(100vh - 180px);
            }
        }
    }

    .prod-item-footer {
        grid-template-columns: auto auto;
        height: 100px;
        /* button {
            // width: 200px;
            // height: 60px;
        } */
    }

    #keyboard {
        .keyboard;
        position: fixed;
        bottom: 0;
        max-width: 760px;
        font-size: 20px;
    }
}

/* Tablet Devices */
@media (min-width: 901px) and (max-width: 1025px) {
    .header {
        height: 130px;
    }

    .page-container {
        height: calc(100vh - 290px);
    }

    .prod-item-page {
        font-size: 1.2rem;

        .prod-item-header-container.alternative-layout {
            .image-container {
                height: 280px;
            }
            .details-container {
                padding: 15px 30px 15px 30px;

                p {
                    font-size: 21px;
                }
            }

            .data-container {
                display: flex;
                flex-direction: column;
                grid-area: datacontainer;
                padding: 15px 0;
                .details-container {
                    padding: 0;
                    display: block;
                    margin: auto;
                    text-align: center;

                    h1 {
                        padding: 0 0;
                        margin: 0 0 15px 0;
                        font-size: 1.9em;
                    }
                }

                .price-container {
                    padding: 0;
                    .price {
                        font-size: 1.9em;
                    }
                }
            }
        }

        .observations-container {
            padding: 0 15px 50px 15px;
            width: calc(100% - 30px);

            .grupo-op-name {
                padding: 10px 15px;
                margin-bottom: 15px;

                span {
                    font-weight: bold;
                    font-size: 2rem;
                }
            }
            .min-observations-message {
                font-size: 19px;
            }
            .typed-obs-text {
                font-size: 26px;
                width: 99%;
            }

            .obs-item-container {
                grid-template-columns: calc(50% - 7.5px) calc(50% - 7.5px);
                grid-column-gap: 15px;

                .item-obs {
                    margin-top: 20px;
                    grid-column-gap: 0;
                    grid-template-columns: 15% calc(85% - 15px);

                    &.quantity-control {
                        grid-template-columns: 40% calc(60% - 15px);
                    }
                }
            }
        }

        #keyboard-filler {
            height: 150px;
        }

        &.slimMode {
            .page-container {
                padding: 10px 0;
                height: calc(100vh - 180px);
            }
        }
    }

    .prod-item-footer {
        grid-template-columns: auto auto;
        height: 100px;
    }

    #keyboard {
        .keyboard;
        position: fixed;
        bottom: 0;
        max-width: 760px;
        font-size: 20px;
    }
}

@media (orientation: landscape) {
    .header {
        height: 90px;
    }

    .page-container {
        height: calc(100vh - 220px);
    }

    .prod-item-page {
        font-size: 1.2rem;

        .prod-item-header-container.alternative-layout {
            display: grid;
            grid-template-columns: 40% 60%;
            grid-template-areas: "prodimage datacontainer"
                                "description description";
            .image-container {
                grid-area: prodimage;
                height: 190px;
                img {
                    object-fit: contain;
                }
            }
            /* Posiciona o container de descrição abaixo do image-container e data-container */
            /* com altura máxima de 200px e overflow vertical */
            .details-container {
                grid-area: description;
                padding: 10px 15px 10px 15px;
                max-height: 100px;
                overflow-y: auto;
                overflow-x: hidden;

                p {
                    font-size: 21px;
                    margin: 5px 0;
                }
            }

            .data-container {
                display: flex;
                flex-direction: column;
                grid-area: datacontainer;
                padding: 15px 0;
                .details-container {
                    padding: 0;
                    display: block;
                    margin: auto;
                    text-align: center;

                    h1 {
                        padding: 0 0;
                        margin: 0 0 15px 0;
                        font-size: 1.7em;
                    }
                }

                .price-container {
                    padding: 0;
                    .price {
                        font-size: 1.7em;
                    }
                }
            }
        }

        .observations-container {
            padding: 10px 15px 50px 15px;
            width: calc(100% - 30px);

            .grupo-op-name {
                padding: 10px 15px;
                margin-bottom: 5px;

                span {
                    font-weight: bold;
                    font-size: 1.6rem;
                }
            }

            .typed-obs-text {
                font-size: 26px;
                width: 99%;
            }
            .min-observations-message {
                font-size: 15px;
            }

            .obs-item-container {
                grid-template-columns: calc(50% - 10px) calc(50% - 10px);
                grid-column-gap: 15px;

                .item-obs {
                    margin-top: 15px;
                    grid-column-gap: 0;
                    grid-template-columns: 15% calc(85% - 15px);
                    padding: 12px 10px;
                    &.quantity-control {
                        grid-template-columns: 40% calc(60% - 15px);
                    }
                }
            }
        }

        #keyboard-filler {
            height: 150px;
        }

        &.slimMode {
            .page-container {
                padding: 10px 0;
                height: calc(100vh - 180px);
            }
        }
    }

    .prod-item-footer {
        grid-template-columns: auto auto;
        height: 100px;
    }

    #keyboard {
        .keyboard;
        position: fixed;
        bottom: 0;
        max-width: 760px;
        font-size: 20px;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/ProductItem.vue